import React, { useState, useEffect } from "react";
import { parseUrl } from "query-string";
import { string, func, bool, number } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import Button from "../../atoms/Button";

import "./popupOverlay.m.css";

const PopupOverlay = ({
  popupMessage,
  onClickHandler,
  showButton = true,
  currentPath,
  buttonType = "",
  buttonContent = "Okay",
  onCloseHandler,
  clientId,
}) => {
  const [callbackUrl, setCallbackUrl] = useState(null);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const buttonText = buttonType === "login" && buttonContent ? buttonContent : "Login";

  const params = parseUrl(currentPath);

  useEffect(() => {
    setCallbackUrl(get(params, ["query", "callback-url"], global.location.origin));
    setRedirectUrl(get(params, ["query", "redirect-url"], global.location.origin));
  }, [params]);

  return (
    <div className="popup-wrapper">
      <div styleName={`popup-container`} className="popup-container">
        {buttonType === "epaper" && <div styleName="attention-message">Attention: Existing users of epaper!!</div>}
        <div styleName="popup-content">{popupMessage}</div>
        {showButton && buttonType !== "login" && buttonType !== "epaper" && buttonType !== "signup" && (
          <Button content={buttonContent} buttonType="type3" onClick={onClickHandler} />
        )}
        {buttonType === "login" && (
          <Link href={callbackUrl}>
            <Button content={buttonText} buttonType="type3" />
          </Link>
        )}
        {buttonType === "signup" && (
          <Link
            href={`api/auth/v1/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUrl}&callback_uri=${callbackUrl}`}
          >
            <Button content={buttonText} buttonType="type3" />
          </Link>
        )}
        {buttonType === "epaper" && (
          <div styleName="epaper-alert">
            <Button content="Close" buttonType="type1" onClick={onCloseHandler} />
            <Button content={buttonContent} buttonType="type3" onClick={onClickHandler} />
          </div>
        )}
      </div>
      <div styleName="bg-overlay"></div>
    </div>
  );
};

PopupOverlay.propTypes = {
  popupMessage: string,
  onClickHandler: func,
  showButton: bool,
  currentPath: string,
  buttonType: string,
  buttonContent: string,
  onCloseHandler: func,
  clientId: number,
};

const mapStateToProps = (state) => ({
  currentPath: get(state, ["qt", "currentPath"], ""),
  clientId: get(state, ["qt", "config", "publisher-attributes", "sso_login", "client_id"], 0),
});

export default connect(mapStateToProps)(PopupOverlay);
